import VerificationPanel from './VerificationPanel';

export default VerificationPanel;
